// extracted by mini-css-extract-plugin
export default {"nav_width_65":"Settings_nav_width_65__CApmo","ml_2":"Settings_ml_2__LoTzJ"};